const LINES = [
  "FEES IN. TOAD OUT.",
  "THE TOAD PAYROLL DEPARTMENT",
  "CHAIRMAN OF THE TUBE",
  "THE OFFICE NEVER CLOSES",
  "YOUR DESK. YOUR SHARE.",
  "$FRONK",
];

export const TickerMarquee = ({ dark = false }) => {
  const items = [...LINES, ...LINES];
  return (
    <div
      className={`fronk-marquee overflow-hidden border-y-2 border-[color:var(--ink-800)] ${
        dark
          ? "bg-[color:var(--ink-800)] text-[color:var(--paper-1)]"
          : "bg-[color:var(--paper-1)] text-[color:var(--ink-800)]"
      }`}
      data-testid="ticker-marquee"
      aria-hidden="true"
    >
      <div className="fronk-marquee-track py-3">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {items.map((line, i) => (
              <span
                key={`${half}-${i}`}
                className="font-mono-ledger flex items-center whitespace-nowrap px-6 text-xs uppercase tracking-[0.22em]"
              >
                {line}
                <span className="ml-12 inline-block h-1.5 w-1.5 rounded-full bg-[color:var(--stamp-500)]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
